import React from 'react';
import { fill } from './labels';

// Standard card chrome — no coloured left stroke. Severity is carried by the icon and
// eyebrow alone (PE-440 comment 2 supersedes the original spec).
export default function AttentionCard({ attention, onRemind, onViewList, labels }) {
  var count = (attention && attention.not_checked_in) || 0;
  var companies = (attention && attention.top_companies) || [];

  var body = count === 0
    ? labels.none
    : fill(
      companies.length ? labels.body : labels.body_no_companies,
      {
        count: count,
        companies: companies.
          map(function (company) {
            return fill(labels.company_entry, { name: company.name, count: company.count });
          }).
          join(', ')
      }
    );

  return (
    <div className="card ehc-monitoring__card ehc-monitoring__card--attention">
      <div className="card-header ehc-monitoring__card-header">
        <span className="ehc-monitoring__eyebrow ehc-monitoring__eyebrow--danger">
          <i className="zmdi zmdi-alert-triangle" />
          {labels.eyebrow}
        </span>
      </div>
      <div className="card-body">
        <p className="ehc-monitoring__attention-body">{body}</p>

        {count > 0 && (
          <div className="ehc-monitoring__attention-actions">
            <button type="button" className="btn btn-sm btn-primary" onClick={onRemind}>
              {labels.remind}
            </button>
            <button type="button" className="btn btn-sm btn-outline-secondary" onClick={onViewList}>
              {labels.view_list}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
